import propTypes from 'prop-types';

export const connectedCalendarDetailsPropType = propTypes.shape({
  email: propTypes.string,
  preferences: propTypes.shape({ allowTentativeEvents: propTypes.bool }),
  provider: propTypes.string.isRequired,
  tokenInvalid: propTypes.bool.isRequired,
});
